<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { renderBarChart } from '../utils/chartBands.js';

const props = defineProps({
	title: { type: String, required: true },
	subtitle: { type: String, default: '' },
	labels: { type: Array, required: true },
	data: { type: Array, required: true },
	colors: { type: Array, required: true },
	axisMin: { type: Number, required: true },
	axisMax: { type: Number, required: true },
	bands: { type: Array, required: true },
	unit: { type: String, default: '' }
});

const canvasEl = ref(null);
let chart = null;

onMounted(() => {
	chart = renderBarChart(canvasEl.value.getContext('2d'), {
		labels: props.labels,
		data: props.data,
		colors: props.colors,
		axisMin: props.axisMin,
		axisMax: props.axisMax,
		bands: props.bands,
		unit: props.unit
	});
});

onBeforeUnmount(() => {
	if (chart) chart.destroy();
});
</script>

<template>
	<div class="tnt-chart-card">
		<div class="tnt-ct-title">{{ title }}</div>
		<div class="tnt-ct-range">{{ subtitle }}</div>
		<canvas ref="canvasEl"></canvas>
	</div>
</template>
